import { bannerHealth, newsContent } from "./../inc/Datamenu_inc";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { useRef, useEffect, useState } from "react";
import Loading from "../component/Loading";
// import { useNavigate } from "react-router-dom";
import Card from "../component/Card";
import { dataFloor } from "./../inc/Datamenu_inc";
import { motion } from "framer-motion";

export default function Home() {
  const containerRef = useRef(null);
  const viewerInstance = useRef(null);
  // const navigate = useNavigate();
  // สถานะเพื่อตรวจสอบว่าขณะนี้เป็นหน้าจอมือถือหรือไม่
  const [isMobile, setIsMobile] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // จํานวนรายการต่อหน้า
  const totalPages = Math.ceil(newsContent.length / itemsPerPage);
  const maxPagesToShow = 3; // จำนวนหน้าที่แสดงใน pagination

  // คำนวณ index ของรายการที่แสดงในหน้าปัจจุบัน
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = newsContent.slice(indexOfFirstItem, indexOfLastItem);

  // ฟังก์ชันเปลี่ยนหน้า
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // สร้าง array ของหน้าที่จะแสดง
  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  useEffect(() => {
    localStorage.removeItem("selectedItem");
    // Initialize Viewer.js สำหรับ container
    if (containerRef.current && !viewerInstance.current) {
      viewerInstance.current = new Viewer(containerRef.current, {
        inline: false,
        title: false,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 1,
          play: 0,
          next: 1,
          rotateLeft: 1,
          rotateRight: 1,
          flipHorizontal: 1,
          flipVertical: 1,
        },
      });
    }

    return () => {
      // ทำลาย Instance เมื่อ Component ถูกลบ
      if (viewerInstance.current) {
        viewerInstance.current.destroy();
        viewerInstance.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      // ตรวจสอบขนาดหน้าจอ หากกว้างน้อยกว่า 768px ให้กำหนด isMobile เป็น true
      setIsMobile(window.innerWidth < 768);
    };

    // เรียกใช้งานฟังก์ชันตรวจสอบขนาดหน้าจอครั้งแรก
    handleResize();

    // เพิ่ม event listener เพื่อตรวจสอบขนาดหน้าจอเมื่อมีการเปลี่ยนแปลง
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount เพื่อป้องกัน memory leak
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const MotionWrapper = isMobile ? "div" : motion.div;

  return (
    <>
      {/* About Us */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 ">
        <div className="flex flex-col gap-y-4">
          <div className="flex flex-col gap-y-2">
            <span className="font-bold text-[#0F4D81] text-2xl">
              NORTHERN REGIONAL VETERINARY HEALTHCARE AND LEARNING CENTER
            </span>
            <span className="font-medium text-gray-800 text-xl">
              ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
            </span>
          </div>

          <div className="text-gray-700 lg:text-base text-sm">
            ศูนย์การเรียนรู้ และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ NOVEL CMU
            เริ่มก่อสร้างเมื่อปี 2562 ณ พื้นที่ศูนย์วิจัย
            สาธิตและฝึกอบรมการเกษตรแม่เหียะ ต.แม่เหียะ อ.เมือง จ.เชียงใหม่
            ซึ่งเป็นบริเวณที่ตั้งของคณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ ณ
            ปัจจุบัน เป็นอาคารสูง 4 ชั้น พื้นที่สอยประมาณ 17,968 ตาราง
            เปิดให้การรักษาโรคทั่วไปและโรคเฉพาะทางที่มีความซับซ้อนอย่างครบวงจร
            ต่อมาได้กราบบังคมทูล
            <b>
              {" "}
              พระกนิษฐาธิราชเจ้า กรมสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี{" "}
            </b>
            ขอพระราชทานชื่ออาคาร "ศูนย์สุขภาพสัตว์ดอยคำ" พระองค์ท่าน
            ทรงกรุณาพระราชทานชื่ออาคารดังกล่าวว่า "สัตวเวชบำรุง" หมายถึง
            อาคารที่แหล่งบำรุงรักษาทางการแพทย์ให้แก่สัตว์
            และพระราชทานพระราชานุญาตให้เชิญอักษรพระนามาภิไธย "ส.ธ."
            ประดับที่ป้ายชื่อพระราชทาน อย่างเป็นทางการเมื่อวันที่ 29 กันยายน
            2567
          </div>
        </div>
        <div className="w-full h-full overflow-hidden flex justify-center">
          <img
            src="/images/banner/banner1.jpg"
            alt=""
            className="object-cover rounded-md"
          />
        </div>
      </div>

      {/* News */}
      <div className="flex flex-col gap-y-2 text-2xl font-bold">
        <div className="flex justify-between items-center gap-x-2 text-[#0F4D81]">
          <div className="flex gap-x-2">
            <i className="fa fa-paw"></i>
            <span>ข่าวประชาสัมพันธ์</span>
          </div>
        </div>
      </div>
      <Loading data={currentItems}>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
          {currentItems.map((item) => (
            <Card key={item.id} item={item} />
          ))}
        </div>
      </Loading>
      {/* Pagination Controls */}
      <div className="flex justify-start ">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="mx-1 px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
        >
          <i className="fa fa-arrow-left"></i>
        </button>

        {currentPage > maxPagesToShow / 2 + 1 && (
          <>
            <button
              onClick={() => paginate(1)}
              className="mx-1 px-3 py-1 rounded bg-gray-200"
            >
              1
            </button>
            <span className="mx-1 px-3 py-1">...</span>
          </>
        )}

        {getPageNumbers().map((page) => (
          <button
            key={page}
            onClick={() => paginate(page)}
            className={`mx-1 px-3 py-1 rounded ${
              currentPage === page
                ? "bg-[#0F4D81] text-white"
                : "bg-gray-200 text-[#0F4D81]"
            }`}
          >
            {page}
          </button>
        ))}

        {currentPage < totalPages - maxPagesToShow / 2 && (
          <>
            <span className="mx-1 px-3 py-1">...</span>
            <button
              onClick={() => paginate(totalPages)}
              className="mx-1 px-3 py-1 rounded bg-gray-200 text-[#0F4D81]"
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="mx-1 px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
        >
          <i className="fa fa-arrow-right"></i>
        </button>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-y-2 text-2xl font-bold">
        <div className="flex justify-between">
          <div className="flex gap-x-2 text-[#0F4D81]">
            <i className="fa fa-paw"></i>
            <span>ความรู้ต่างๆเกี่ยวกับสัตว์เลี้ยง</span>
          </div>
        </div>
      </div>

      {/* ใช้ ref ที่ Container แทนแต่ละรูปภาพ */}
      <div
        ref={containerRef}
        className="grid md:grid-cols-4 grid-cols-2 justify-center items-center gap-3"
      >
        {bannerHealth.map((item, index) => (
          <div key={item.id} className="relative group w-full h-96">
            <img
              src={item.img ? item.img : "/images/info/notImg.png"}
              alt={`ความรู้เกี่ยวกับสัตว์เลี้ยง ${index + 1}`}
              className="object-cover rounded-md shadow shadow-blue-300 w-full h-full"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  // เรียกแสดงรูปภาพตาม Index
                  if (viewerInstance.current) {
                    viewerInstance.current.view(index);
                  }
                }}
                className="bg-gray-400/50  text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Floor */}
      <MotionWrapper
        className="flex flex-col gap-y-4 px-4 sm:px-6 md:px-8"
        {...(!isMobile && {
          // initial: { opacity: 0, y: 50 },
          initial: false,
          // whileInView: { opacity: 1, y: 0 },
          viewport: { once: false, amount: 0.5 },
          // transition: { duration: 0.8, ease: "easeOut" },
        })}
      >
        <div className="grid grid-cols-1 md:grid-cols-1 space-y-4">
          <div className="flex flex-col w-full gap-3 border p-3 border-gray-100 rounded-lg shadow-md">
            <MotionWrapper
              className="flex justify-start items-start space-x-3 text-3xl sm:text-4xl md:text-5xl font-bold text-[#0F4D81] border-b-2 py-2"
              {...(!isMobile && {
                // initial: { opacity: 0, x: -50 },
                initial: false,
                // whileInView: { opacity: 1, x: 0 },
                // transition: { duration: 0.8, ease: "easeOut" },
              })}
            >
              <span>
                <i className="fa-solid fa-layer-group text-[#9E76B3]"></i>
              </span>
              <span>Floor (ชั้น)</span>
            </MotionWrapper>
            {dataFloor.length > 0 &&
              dataFloor.map((item, index) => (
                <MotionWrapper
                  key={index}
                  className="flex flex-col md:flex-row relative border-b-2 px-2 py-5 gap-x-3"
                  {...(!isMobile && {
                    // initial: { opacity: 0, y: 50 },
                    initial: false,
                    // whileInView: { opacity: 1, y: 0 },
                    // transition: {
                    //   duration: 0.8,
                    //   ease: "easeOut",
                    //   delay: index * 0.2,
                    // },
                  })}
                >
                  <div className="hidden md:flex text-5xl sm:text-6xl md:text-7xl font-medium text-[#0F4D81] border-r-2 pr-2">
                    {item.floor}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center text-[80px] sm:text-[120px] md:text-[150px] font-bold text-[#0F4D81] opacity-10">
                    {item.floor}
                  </div>
                  <div className="w-full h-full">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                      {item?.rooms.length > 0 &&
                        item?.rooms.map((room, index) => (
                          <MotionWrapper
                            key={index}
                            className="flex flex-col text-center"
                            {...(!isMobile && {
                              // initial: { opacity: 0, scale: 0.8 },
                              initial: false,
                              // whileInView: { opacity: 1, scale: 1 },
                              // transition: {
                              //   duration: 0.5,
                              //   ease: "easeOut",
                              //   delay: index * 0.1,
                              // },
                            })}
                          >
                            <div className="text-[#9E76B3] text-base sm:text-lg">
                              {room.roomname_th}
                            </div>
                            <div className="text-[12px] sm:text-[14px] text-[#0F4D81]">
                              {room.roomname_en}
                            </div>
                          </MotionWrapper>
                        ))}
                    </div>
                  </div>
                </MotionWrapper>
              ))}
          </div>
        </div>
      </MotionWrapper>
    </>
  );
}
